angular
    .module('MyHippoProducer.Services')
    .factory('GraphqlService', function ($http, Auth0Service) {
        function fetch(query) {
            const getHeaders = () => Auth0Service.getPodToken().then((podToken) => ({
                'Content-Type': 'application/json',
                Authorization: `Bearer ${podToken}`
            })).catch((error) => {
                console.error('Error while trying to get POD token:', error);
            });

            return getHeaders().then(headers => $http.post(`${window.BFF_HOST}/graphql`, JSON.stringify({ query: query }), {
                withCredentials: false,
                headers
            }));
        }

        const graphqlService = {
            fetch,
        };
        return graphqlService;
    });
